<div [@ngIfAnimation] *ngIf="showButton"
     class="fixed bottom-11 right-0 z-50 h-16 w-16"
     (click)="scroll()">
  <div class="group h-full w-full relative">
    <div
         class="absolute h-full w-full top-0 left-0 cursor-pointer bg-transparent border-t-[64px] border-r-[64px] border-l-transparent border-t-transparent group-hover:border-r-primary-dark group-hover:border-b-primary-dark border-r-primary-main border-b-primary-main">
    </div>

    <app-icon [@bounceAnimation]
              class="z-[9999] cursor-pointer absolute top-[1.125rem] left-[1.125rem] h-4 w-4 text-white"
              [icon]="'arrow-up'"></app-icon>

  </div>
</div>
